import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import serialize from 'form-serialize';
import deepmerge from 'deepmerge';
import FormSaveButtons from './FormSaveButtons';
import FieldGroup from './FieldGroup';
import BootstrapForm from 'react-bootstrap/lib/Form';
import ConfirmationModal from '../ConfirmationModal';
import CancelConfirmModal from '../CancelConfirmModal';
import AlertMessage from '../AlertMessage';
import { AlertMessageTypes } from '../../constants/index';
import i18n from '../../../src/i18n/translate';
import JsonApiRecordDecorator from "../../json-api/JsonApiRecordDecorator";

export default class Form extends React.Component {
  static propTypes = {
    activeLanguage: PropTypes.object,
    addAction: PropTypes.func,
    buttonGroupClass: PropTypes.string,
    buttonStyle: PropTypes.string,
    buttonStyleDelete: PropTypes.string,
    buttonStyleSecondary: PropTypes.string,
    cancelButton: PropTypes.bool,
    cancelButtonText: PropTypes.string,
    cancelConfirmText: PropTypes.object,
    cancelIconType: PropTypes.string,
    clearMessages: PropTypes.func,
    children: PropTypes.any,
    data: PropTypes.object.isRequired,
    deepMerge: PropTypes.bool,
    deleteAction: PropTypes.func,
    deleteButton: PropTypes.bool,
    deleteButtonText: PropTypes.string,
    deleteDisableButtons: PropTypes.bool,
    deleteIconType: PropTypes.sgring,
    deleteModalTitle: PropTypes.string,
    deleteModalBody: PropTypes.string,
    deleteModalConfirmButtonText: PropTypes.string,
    deleteModalCancelButtonText: PropTypes.string,
    disableButtons: PropTypes.bool,
    errorMessage: PropTypes.string,
    fieldGroupClass: PropTypes.string,
    hasFormButtons: PropTypes.bool,
    languages: PropTypes.arrayOf(PropTypes.object),
    leftButtonStyle: PropTypes.string,
    leftButtonText: PropTypes.string,
    leftButtonClick: PropTypes.func,
    leftButtonIconType: PropTypes.string,
    noPaddingButtons: PropTypes.bool,
    onCancel: PropTypes.func,
    onCancelClose: PropTypes.func,
    onInvalidFormSubmit: PropTypes.func,
    saveAndAddButton: PropTypes.bool,
    saveAndAddButtonText: PropTypes.string,
    saveAndAddCheckbox: PropTypes.bool,
    saveAndAddCheckboxText: PropTypes.string,
    saveAndAddIconType: PropTypes.string,
    saveButton: PropTypes.bool,
    saveButtonAreaClassName: PropTypes.string,
    saveButtonDisabled: PropTypes.bool,
    saveButtonText: PropTypes.string,
    saveButtonDataAction: PropTypes.string,
    saveComplete: PropTypes.func,
    saveIconType: PropTypes.string,
    scrollContainerId: PropTypes.string,
    showAlertMessages: PropTypes.bool,
    skipCancelConfirmation: PropTypes.bool,
    successMessage: PropTypes.string,
    triggerCancel: PropTypes.bool,
    triggerSave: PropTypes.bool,
    triggerSaveAndAdd: PropTypes.bool,
    updateAction: PropTypes.func
  };

  static defaultProps = {
    cancelButton: true,
    deepMerge: false,
    deleteButton: false,
    deleteDisableButtons: true,
    deleteModalBody: '',
    hasFormButtons: true,
    showAlertMessages: true,
    saveAndAddButton: false,
    saveButton: true,
    saveButtonDisabled: false
  };

  constructor(props){
    super(props);
    this.state = {
      errorMessage: props.errorMessage,
      isDisabled: props.disableButtons,
      deleteModal: false
    };
  }

  async componentWillReceiveProps(newProps){
    if(newProps.disableButtons === false || newProps.errorMessage || newProps.successMessage){
      this.setState({ isDisabled: false });
    }
    if(newProps.errorMessage && newProps.errorMessage !== this.props.errorMessage){
      this.setState({ errorMessage: newProps.errorMessage, runValidation: true, isDisabled: false });
    }
    if ((newProps.triggerSave && !this.props.triggerSave) || (newProps.triggerSaveAndAdd && !this.props.triggerSaveAndAdd)) {
      try {
        let addAnother = newProps.triggerSaveAndAdd;
        let formValidated = await this.save(addAnother);
        this.props.saveComplete(!!formValidated);
      } catch(e){
        this.setState({ errorMessage: e.message, runValidation: true, isDisabled: false });
        this.props.saveComplete(false);
      }
    }
    if (newProps.triggerCancel && !this.props.triggerCancel) {
      this.onCancel();
    }
  }

  toggleDeleteModal = () => {
    this.setState({ deleteModal: !this.state.deleteModal });
  }

  onValueChange = (obj) => {
    Object.assign(this.props.data, obj);
  }

  save = async (addAnother) => {
    let form = ReactDOM.findDOMNode(this.bootstrapForm);
    if (form.checkValidity()) {
      const currentData = this.serializeForm(form);
      if (currentData.id) {
        if (this.props.updateAction){
          this.props.updateAction(currentData);
        }
      } else {
        if (this.props.addAction){
          this.props.addAction(currentData, addAnother);
        }
      }
      return currentData;
    } else {
      this.setState({ errorMessage: 'Errors on the form!', runValidation: true, isDisabled: false });

      if (typeof this.props.onInvalidFormSubmit === 'function') {
        this.props.onInvalidFormSubmit();
      }

      return false;
    }
  }

  saveAndAdd = (e) => {
    e.preventDefault();
    this.setState({ isDisabled: true });
    this.save(true);
  }

  saveAndClose = (e) => {
    e.preventDefault();
    this.setState({ isDisabled: true });
    this.save();
  }

  onCancel = () => {
    const form = ReactDOM.findDOMNode(this.bootstrapForm);
    const currentData = this.serializeForm(form);

    if (currentData.isDirty && !this.props.skipCancelConfirmation) {
      this.setState({ showCancelConfirm: true });
    } else {
      this.props.onCancel();
    }
  }

  serializeForm = (form) => {
    let obj = serialize(form, { hash: true, empty: true });
    //form-serialize does not serialize checkbox array correctly if only last item is checked
    Object.keys(obj).map((key)=>
    {
      if(Array.isArray(this.props.data[key])) {
        if (!Array.isArray(obj[key]) && !!obj[key]) {
          let temp = obj[key];
          obj[key] = [];
          obj[key].push(temp);
        }
      }
      if(Array.isArray(obj[key])) {
        obj[key] = obj[key].filter(val => !!val);
      }
    });
    const newData = new JsonApiRecordDecorator();
    if (this.props.deepMerge) {
      Object.assign(newData, this.props.data, deepmerge(newData, this.props.data, obj));
    } else {
      Object.assign(newData, this.props.data, obj);
    }
    return newData;
  }

  onCancelClose = (close) => {
    this.setState({ showCancelConfirm: false });
    if (close) {
      this.props.onCancel();
    } else if (this.props.onCancelClose) {
      this.props.onCancelClose();
    }
  }

  deleteRecord = () => {
    if (this.props.deleteDisableButtons) {
      this.setState({ isDisabled: true });
    }
    this.props.deleteAction(this.props.data);
    this.toggleDeleteModal();
  }

  render() {
    let saveForm = this.props.saveButton ? this.saveAndClose : null;
    // If data has id this is an update = don't show checkbox
    let saveAndAddCheckbox = false;
    if(this.props.saveAndAddCheckbox && !this.props.data.id) {
      saveForm = this.saveAndAdd;
      saveAndAddCheckbox = this.props.saveAndAddCheckbox;
    }
    const cancel = this.props.cancelButton ? this.onCancel : null;
    const saveAndAdd = this.props.saveAndAddButton ? this.saveAndAdd : null;
    const deleteButton = this.props.deleteButton ? this.deleteRecord : null;
    const deleteToggleButton = this.props.deleteButton ? this.toggleDeleteModal : null;
    const {
      deleteModalTitle,
      deleteModalConfirmButtonText,
      deleteModalCancelButtonText
    } = Object.assign({
      deleteModalTitle: i18n.t("Are you sure?"),
      deleteModalConfirmButtonText: i18n.t("Yes"),
      deleteModalCancelButtonText: i18n.t("Cancel")
    }, this.props)

    return (
      <BootstrapForm ref={(form) => (this.bootstrapForm = form)}>
        <ConfirmationModal
          confirmButtonText={deleteModalConfirmButtonText}
          cancelButtonText={deleteModalCancelButtonText}
          canClickOff={true}
          onConfirm={deleteButton}
          onCancel={this.toggleDeleteModal}
          show={this.state.deleteModal}
          title={deleteModalTitle}
        >
          <div>{this.props.deleteModalBody}</div>
        </ConfirmationModal>
        <CancelConfirmModal
          {...this.props.cancelConfirmText}
          onCancelClose={this.onCancelClose}
          show={this.state.showCancelConfirm}
        />
        {this.props.showAlertMessages && this.props.errorMessage && (
          <AlertMessage
            clearMessages={this.props.clearMessages}
            message={this.props.errorMessage}
            messageType={AlertMessageTypes.danger}
            visible={true}
          />
        )}
        <FieldGroup
          activeLanguage={this.props.activeLanguage}
          className={this.props.fieldGroupClass}
          data={this.props.data}
          languages={this.props.languages}
          onValueChange={this.onValueChange}
          runValidation={this.state.runValidation}
          scrollContainerId={this.props.scrollContainerId}
        >
          {this.props.children}
        </FieldGroup>
        {this.props.hasFormButtons && <FormSaveButtons
          buttonStyle={this.props.buttonStyle}
          buttonStyleDelete={this.props.buttonStyleDelete}
          buttonStyleSecondary={this.props.buttonStyleSecondary}
          cancel={cancel}
          cancelButtonText={this.props.cancelButtonText}
          cancelIconType={this.props.cancelIconType}
          className={this.props.buttonGroupClass}
          dataId={this.props.data && this.props.data.id ? this.props.data.id : ''}
          dataType={this.props.data && this.props.data.type ? this.props.data.type : ''}
          delete={deleteToggleButton}
          deleteButtonText={this.props.deleteButtonText}
          deleteIconType={this.props.deleteIconType}
          isDisabled={this.state.isDisabled}
          leftButtonStyle={this.props.leftButtonStyle}
          leftButtonText={this.props.leftButtonText}
          leftButtonClick={this.props.leftButtonClick}
          leftButtonIconType={this.props.leftButtonIconType}
          noPaddingButtons={this.props.noPaddingButtons}
          saveAndAddCheckbox={saveAndAddCheckbox}
          saveAndAddCheckboxText={this.props.saveAndAddCheckboxText}
          save={saveForm}
          saveAndAdd={saveAndAdd}
          saveAndAddButtonText={this.props.saveAndAddButtonText}
          saveAndAddIconType={this.props.saveAndAddIconType}
          saveButtonAreaClassName={this.props.saveButtonAreaClassName}
          saveButtonDisabled={this.props.saveButtonDisabled}
          saveButtonText={this.props.saveButtonText}
          saveButtonDataAction={this.props.saveButtonDataAction}
          saveIconType={this.props.saveIconType}
        />}
      </BootstrapForm>
    );
  }
}
